import React, { useCallback } from 'react';
import { Flex, Box, ButtonV2 } from '@withjoy/joykit';
import { DepartmentsTree, DepartmentsTreeProps } from '../DepartmentsTree/DepartmentsTree';
import { ReactComponent as JoyLogo } from '@assets/joy-logo.svg';
import { pxToRem } from '@withjoy/joykit/theme';
import { useFooterTranslations } from './DepartmentFooter.utils';
import { useAdminRegistryTelemetry } from '@apps/registry/admin/AdminRegistry.telemetry';
import { footerButtonOverrides } from './DepartmentFooter.styles';

const footerLinks = [
  {
    key: 'shipping',
    url: 'https://withjoy.com/shipping-policy',
    translationKey: 'shipping',
  },
  {
    key: 'returns',
    url: 'https://withjoy.com/return-policy',
    translationKey: 'returns',
  },
  {
    key: 'terms',
    url: 'https://withjoy.com/eula/',
    translationKey: 'termsAndPrivacy',
  },
  {
    key: 'support',
    url: 'https://help.withjoy.com',
    translationKey: 'support',
  },
] as const;

export const DepartmentsFooter = (props: DepartmentsTreeProps) => {
  const translations = useFooterTranslations();
  const telemetry = useAdminRegistryTelemetry();

  const handleClick = useCallback(
    (key: string) => {
      telemetry.footerLinkClicked(key);
    },
    [telemetry],
  );

  return (
    <Flex
      height="100%"
      backgroundColor="gray1"
      paddingX={pxToRem(35)}
      paddingY={pxToRem(64)}
      alignItems="center"
      flexDirection="column"
    >
      <DepartmentsTree {...props} />
      <Box
        marginBottom={pxToRem(35)}
        marginTop={pxToRem(80)}
        textAlign="center"
        color="gray3"
      >
        <JoyLogo />
      </Box>
      <Flex gap={{ _: 20, sm: 7 }}>
        {footerLinks.map(({ key, url, translationKey }) => (
          <ButtonV2
            target="_blank"
            as="a"
            href={url}
            key={key}
            variant="ghost"
            overrides={footerButtonOverrides}
            onClick={() => handleClick(key)}
          >
            {translations[translationKey]()}
          </ButtonV2>
        ))}
      </Flex>
    </Flex>
  );
};
